// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__2gcJs","footer":"ReportModalFilter_footer__cITz-"};